import React from "react";
import { IconBase, type IconProps } from "./IconBase";
import dashboardIconSVG from "images/icons/dashboard.svg";

export const DashboardIcon = (props: IconProps) => {
  return <IconBase {...props} href={dashboardIconSVG} />;
};
